import { create } from "apisauce";
import { store } from "../store/index";

const { aiwritemate } = store?.getState();

const interPretor = create({
  baseURL: "https://tg399jo3w5.execute-api.ap-south-1.amazonaws.com/dev/api",
  timeout: 600000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-access-token": aiwritemate?.token,
    Pragma: "no-cache",
    "Cache-Control": "no-cache",
  },
});
interPretor.addResponseTransform((response) => {
  if (response.problem === "TIMEOUT_ERROR") {
    throw new Error("TIMEOUT_ERROR"); // throw an error if the API call times out
  }
});
// interPretor.addRequestTransform((request) => {
//   request.timeout = 1000; // set the timeout on the request object as well
// });

// interPretor.addResponseTransform((response) => {
//   if (response.problem === 'TIMEOUT_ERROR') {
//     setModalOpen(true); // open the Material UI modal if the API call times out
//   }
// });

//   interPretor.axiosInstance.interceptors.response.use((response) => {
//   return response
// },
// async function (error) {
// //   console.log(error.code)
// //  if(error.code==="ECONNABORTED")
// //  {

// //  }
// //   console.log(error.code,"error")
// //   if(error.response.status===401){
// // alert("expire token")
// //   }
//   return Promise.reject(error);
// });

export default interPretor;
